import {
  Button,
  Card,
  Col,
  DatePicker,
  Divider,
  Form,
  Input,
  InputNumber,
  Row,
  Select,
  Space,
  Switch,
  Typography,
} from "antd";
import { useEffect, useState } from "react";
import FormService from "./FormService";
import ListServices from "./ListServices";
import { useNavigate, useParams } from "react-router-dom";
import { create, getById, update } from "../../services/sales.service";
import { getAll as loadServices } from "../../services/services.service";
import { getAll as loadCustomers } from "../../services/customers.service";
import { getAll as loadSellers } from "../../services/users.service";
import { AlertService } from "../../services/alert.service";
import { useMutation, useQuery } from "react-query";
import ConfirmModal from "../../components/Commons/Modal/confirm-modal.component";
import { DatePickerProps } from "antd/lib";
import moment from "moment";
import dayjs from "dayjs";
import { useLoggedUser } from "../../Hooks/useLoggedUser";
import { paymentMethods } from "../../Enums/PaymentMethod.enums";
import { salesStatus } from "../../Enums/SalesStatus.enums";
import { getAccountDetails } from "../../services/accounts.service";
import { formatCurrency } from "../../services/utils";
import { sendInvoice } from "../../services/invoices.service";

const { Title } = Typography;
const { TextArea } = Input;

export default function FormSale(props: any) {
  const { loggedUser } = useLoggedUser();
  const [date, setDate] = useState<string>("");
  const [dueDate, setDueDate] = useState<string>("");
  const [services, setServices] = useState<any[]>([]);
  const [customers, setCustomers] = useState<any[]>([]);
  const [sellers, setSellers] = useState<any[]>([]);
  const [saleServices, setSaleServices] = useState<any[]>([]);
  const [sendEmailCharge, setSendEmailCharge] = useState<boolean>(true);
  const [allowedPaymentMethods, setAllowedPaymentMethods] = useState<any[]>(paymentMethods);

  const [valuesChanged, setValuesChanged] = useState<boolean>(false);
  const [leaveThePage, setLeaveThePage] = useState<boolean>(false);

  const [totalServices, setTotalServices] = useState<number>(0);
  const [totalAmount, setTotalAmount] = useState<number>(0);

  const installmentsOptions = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

  const { uuid } = useParams();

  const [formSale] = Form.useForm();
  const paymentMethod = Form.useWatch("payment_method", formSale);
  const navigate = useNavigate();

  const [openSendUpdatedInvoiceConfirm, setOpenSendUpdatedInvoiceConfirm] = useState<boolean>(false);
  const [sendingUpdatedInvoiceLoading, setSendingUpdatedInvoiceLoading] = useState<boolean>(false);
  const [nextInvoiceUuidToSend, setNextInvoiceUuidToSend] = useState<string>("");

  const settings = {
    create: { title: "Criar venda", alertMessage: "gravada" },
    edit: { title: "Editar venda", alertMessage: "editada" },
    duplicate: { title: "Duplicar venda", alertMessage: "duplicada" },
  };

  const goSalesList = () => {
    navigate(`/sales`);
  };

  const onAddService = (values: any) => {
    setSaleServices(saleServices.concat(values));
    setValuesChanged(true);
  };

  const onUpdateSaleService = (service_id: any, values: any) => {
    let _saleServices = [...saleServices];

    let idx = _saleServices.findIndex((item) => item.service_id == service_id);

    if (idx > -1) {
      _saleServices[idx] = values;

      setSaleServices(_saleServices);
      setValuesChanged(true);
    }
  };

  const onRemoveService = (service_id: any) => {
    setSaleServices(
      saleServices.filter(
        (tableService: any) => tableService.service_id != service_id
      )
    );
    setValuesChanged(true);
  };

  const { isLoading: loadingSale } = useQuery(
    ["loadSale", uuid],
    () => (uuid ? getById(uuid) : null),
    {
      onSuccess: (response) => {
        if (response) {
          const values = response.data;

          setSaleServices(values.saleServices);
          setSendEmailCharge(values.send_email_charge);

          values.date = dayjs(values?.date);
          setDate(values?.date);

          values.due_date = dayjs(values?.due_date);
          setDueDate(values?.due_date);

          formSale.setFieldsValue(values);
        }
      },
      refetchOnWindowFocus: false,
    }
  );

  useQuery(["loadCustomers"], () => loadCustomers({ status: "active" }), {
    onSuccess: (response) => {
      setCustomers(
        response.data.map((customer: any) => {
          return {
            key: customer.data.id,
            value: customer.data.id,
            label: customer.data.name,
          };
        })
      );
    },
    refetchOnWindowFocus: false,
  });

  useQuery(["loadSellers"], () => loadSellers({ status: "active" }), {
    onSuccess: (response) => {
      setSellers(
        response.data.map((seller: any) => {
          return {
            key: seller.id,
            value: seller.id,
            label: seller.name,
          };
        })
      );
    },
    refetchOnWindowFocus: false,
  });

  useQuery(["loadServices"], () => loadServices({ status: "active" }), {
    onSuccess: (response) => {
      setServices(
        response.data.map((service: any) => {
          return {
            key: service.data.id,
            value: service.data.id,
            label: service.data.name,
            price: service.data.value,
          };
        })
      );
    },
    refetchOnWindowFocus: false,
  });

  useQuery(["getAccountDetails"], () => getAccountDetails(), {
    onSuccess: (response) => {
      const settings =
        typeof response?.data?.settings === "string"
          ? JSON.parse(response?.data?.settings)
          : response?.data?.settings || {};

      const allowed = paymentMethods.filter((m) =>
        (settings?.payment_methods || []).includes(m.value)
      );

      const options = allowed.length ? allowed : paymentMethods;
      setAllowedPaymentMethods(options);

      const current = formSale.getFieldValue("payment_method");
      if (!options.some((m) => m.value === current)) {
        formSale.setFieldValue("payment_method", options[0]?.value);
      }
    },
    refetchOnWindowFocus: false,
  });

  const { mutate: createSale, isLoading: createSaleLoading } = useMutation(
    create,
    {
      onSuccess: (response) => {
        AlertService.sendAlert([
          {
            text: `A venda foi ${
              settings[props.action as keyof typeof settings].alertMessage
            } com sucesso.`,
            nextPage: true,
          },
        ]);

        goSalesList();
      },
    }
  );

  const { mutate: updateSale, isLoading: updateSaleLoading } = useMutation(
    update,
    {
      onSuccess: async () => {
        AlertService.sendAlert([
          {
            text: `A venda foi ${
              settings[props.action as keyof typeof settings].alertMessage
            } com sucesso.`,
            nextPage: true,
          },
        ]);

        if (uuid) {
          try {
            const response = await getById(uuid);
            const invoices = response?.data?.invoices || [];

            const today = moment();
            const limit = moment().add(3, "days");
            const isPending = (status: string) =>
              ["Pending", "Pendente"].includes(status || "");

            const parseDue = (d: string) => moment(d, "YYYY-MM-DD");

            const candidate = invoices
              .filter(
                (inv: any) =>
                  isPending(inv?.status || "") &&
                  inv?.due_date &&
                  parseDue(inv?.due_date).isSameOrAfter(today, "day") &&
                  parseDue(inv?.due_date).isSameOrBefore(limit, "day")
              )
              .sort((a: any, b: any) =>
                parseDue(a.due_date).diff(parseDue(b.due_date))
              )[0];

            if (candidate?.uuid) {
              setNextInvoiceUuidToSend(candidate.uuid);
              setOpenSendUpdatedInvoiceConfirm(true);
              return;
            } else {
              goSalesList();
            }
          } catch {}
        }
      },
    }
  );

  const onChangeDate: DatePickerProps["onChange"] = (date, dateString) => {
    setDate(moment(dateString, "DD/MM/YYYY").format("YYYY-MM-DD"));
  };

  const onChangeDueDate: DatePickerProps["onChange"] = (date, dateString) => {
    setDueDate(moment(dateString, "DD/MM/YYYY").format("YYYY-MM-DD"));
  };

  const onSubmit = () => {
    if (!saleServices.length) {
      AlertService.sendAlert([
        {
          text: "É obrigatório adicionar ao menos um serviço para prosseguir.",
          type: "error",
        },
      ]);

      return;
    }

    formSale
      .validateFields()
      .then((values) => {
        values.date =
          typeof date === "object" ? dayjs(date).format("YYYY-MM-DD") : date;

        values.due_date =
          typeof dueDate === "object"
            ? dayjs(dueDate).format("YYYY-MM-DD")
            : dueDate;

        values.services = saleServices.map((service) => ({
          id: service.service_id,
          price: service.price,
          quantity: service.quantity,
        }));

        if (!uuid || props.action === "duplicate") {
          createSale(values);
        } else {
          updateSale({
            values,
            uuid,
          });
        }
      })
      .catch(() =>
        AlertService.sendAlert([
          { text: "Campo(s) com preenchimento inválido", type: "error" },
        ])
      );
  };

  const calcTotalAmount = () => {
    let discount = formSale.getFieldValue("discount") || 0;
    let total = totalServices - (totalServices * discount) / 100;

    formSale.setFieldValue("total_amount", total);

    setTotalAmount(total);
  };

  const onChangeSendEmailCharge = (value: boolean) => {
    setSendEmailCharge(value);
  };

  useEffect(() => {
    if (!uuid) {
      const today = new Date();
      const _date = dayjs(
        today.getFullYear() +
          "-" +
          (today.getMonth() + 1) +
          "-" +
          today.getDate()
      );

      formSale.setFieldsValue({
        date: _date,
        due_date: _date,
        seller_id: loggedUser?.id || null,
        discount: 0,
        installments: 1,
        send_email_charge: true,
        payment_method: "Pix",
        status: "Confirmed",
      });

      setDate(
        today.getFullYear() +
          "-" +
          (today.getMonth() + 1) +
          "-" +
          today.getDate()
      );
      setDueDate(
        today.getFullYear() +
          "-" +
          (today.getMonth() + 1) +
          "-" +
          today.getDate()
      );
    }
  }, [uuid]);

  useEffect(() => {
    setTotalServices(
      saleServices.reduce(
        (total, service) => (total += service.price * service.quantity),
        0
      )
    );
  }, [saleServices]);

  useEffect(() => {
    calcTotalAmount();
  }, [totalServices]);

  return (
    <>
      <Card
        color="primary"
        styles={{
          header: {
            color: "#107B99",
            fontWeight: 600,
          },
        }}
        title={settings[props.action as keyof typeof settings].title}
        loading={loadingSale}
      >
        <Form
          form={formSale}
          name="form_table"
          layout="vertical"
          autoComplete="off"
        >
          <Row gutter={20}>
            <Col span={24}>
              <Title level={5} style={{ marginTop: 0 }}>
                Dados da Venda
              </Title>
            </Col>

            <Col
              lg={{ span: 8 }}
              md={{ span: 8 }}
              sm={{ span: 24 }}
              xs={{ span: 24 }}
            >
              <Form.Item
                name="date"
                label="Data de Emissão"
                rules={[{ required: true, message: "Campo obrigatório" }]}
              >
                <DatePicker
                  size="large"
                  placeholder="Data"
                  showNow={true}
                  format={"DD/MM/YYYY"}
                  style={{ width: "100%" }}
                  onChange={onChangeDate}
                />
              </Form.Item>
            </Col>

            <Col
              lg={{ span: 8 }}
              md={{ span: 8 }}
              sm={{ span: 24 }}
              xs={{ span: 24 }}
            >
              <Form.Item
                label="Cliente"
                name="customer_id"
                rules={[{ required: true, message: "Campo obrigatório" }]}
              >
                <Select
                  placeholder="Selecione o cliente"
                  size="large"
                  options={customers}
                />
              </Form.Item>
            </Col>

            <Col
              lg={{ span: 8 }}
              md={{ span: 8 }}
              sm={{ span: 24 }}
              xs={{ span: 24 }}
            >
              <Form.Item
                label="Vendedor"
                name="seller_id"
                rules={[{ required: true, message: "Campo obrigatório" }]}
              >
                <Select
                  placeholder="Selecione o vendedor"
                  size="large"
                  options={sellers}
                />
              </Form.Item>
            </Col>
          </Row>

          <Divider />

          <Row gutter={20}>
            <Col span={24}>
              <Title level={5} style={{ marginTop: 0 }}>
                Itens da Venda
              </Title>
            </Col>

            <Col span={24}>
              <FormService
                services={services}
                existedServices={saleServices}
                loading={createSaleLoading || updateSaleLoading}
                onAddService={onAddService}
              />
            </Col>

            <Col span={24}>
              <ListServices
                services={services}
                saleServices={saleServices}
                totalServices={totalServices}
                onRemoveService={onRemoveService}
                onUpdateSaleService={onUpdateSaleService}
              />
            </Col>
          </Row>

          <Row gutter={20} style={{ marginTop: 30 }}>
            <Col
              lg={{ span: 4 }}
              md={{ span: 4 }}
              sm={{ span: 12 }}
              xs={{ span: 12 }}
            >
              <Form.Item label="Desconto %" name="discount">
                {}
                <InputNumber
                  min={0}
                  size="large"
                  style={{ width: "100%" }}
                  maxLength={5}
                  formatter={(value) =>
                    `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ".")
                  }
                  onChange={() => calcTotalAmount()}
                />
              </Form.Item>
            </Col>

            <Col
              lg={{ span: 4 }}
              md={{ span: 4 }}
              sm={{ span: 12 }}
              xs={{ span: 12 }}
            >
              <Form.Item
                label="Valor da Venda"
                name="total_amount"
                rules={[{ required: true, message: "Campo obrigatório" }]}
              >
                <InputNumber
                  min={1}
                  size="large"
                  style={{ width: "100%", display: "none" }}
                  maxLength={5}
                  disabled
                />
                <b>{formatCurrency(totalAmount)}</b>
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={20}>
            <Col span={24}>
              <Form.Item label="Discriminação" name="description">
                <TextArea size="large" showCount maxLength={255} />
              </Form.Item>
            </Col>
          </Row>

          <Divider />

          <Row gutter={20}>
            <Col span={24}>
              <Title level={5} style={{ marginTop: 0 }}>
                Cobrança
              </Title>
            </Col>

            <Col
              lg={{ span: 6 }}
              md={{ span: 6 }}
              sm={{ span: 24 }}
              xs={{ span: 24 }}
            >
              <Form.Item
                label="Meio de Pagamento"
                name="payment_method"
                rules={[{ required: true, message: "Campo obrigatório" }]}
              >
                <Select
                  placeholder="Selecione o método de pagamento"
                  size="large"
                  options={allowedPaymentMethods}
                />
              </Form.Item>
            </Col>

            <Col
              lg={{ span: 6 }}
              md={{ span: 6 }}
              sm={{ span: 24 }}
              xs={{ span: 24 }}
            >
              <Form.Item
                label="Parcelas"
                name="installments"
                rules={[{ required: true, message: "Campo obrigatório" }]}
              >
                <Select
                  placeholder="Selecione uma opção de parcelamento"
                  size="large"
                >
                  {installmentsOptions.map((option) => {
                    return (
                      <Select.Option
                        key={String(option)}
                        value={option}
                      >{`${String(option)}x${
                        totalAmount
                          ? ` de ${formatCurrency(
                              totalAmount / Number(option)
                            )}`
                          : ""
                      }`}</Select.Option>
                    );
                  })}
                </Select>
              </Form.Item>
            </Col>

            <Col
              lg={{ span: 6 }}
              md={{ span: 6 }}
              sm={{ span: 24 }}
              xs={{ span: 24 }}
            >
              <Form.Item
                name="due_date"
                label="Data de Vencimento"
                rules={[{ required: true, message: "Campo obrigatório" }]}
              >
                <DatePicker
                  size="large"
                  placeholder="Data"
                  showNow={true}
                  format={"DD/MM/YYYY"}
                  style={{ width: "100%" }}
                  onChange={onChangeDueDate}
                />
              </Form.Item>
            </Col>

            <Col span={24}>
              <Form.Item
                label="Enviar cobrança por e-mail"
                name="send_email_charge"
              >
                <Switch
                  checked={sendEmailCharge}
                  onChange={onChangeSendEmailCharge}
                />
              </Form.Item>
            </Col>
          </Row>
        </Form>

        <Divider />

        <Row
          style={{
            marginTop: 20,
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <Col></Col>
          <Col>
            <Space>
              <Button
                loading={createSaleLoading || updateSaleLoading}
                size="large"
                onClick={() => {
                  if (!uuid || valuesChanged) {
                    setLeaveThePage(true);
                  } else {
                    goSalesList();
                  }
                }}
              >
                Voltar
              </Button>

              <Button
                type="primary"
                loading={createSaleLoading || updateSaleLoading}
                size="large"
                onClick={onSubmit}
              >
                Gravar
              </Button>
            </Space>
          </Col>
        </Row>

        <ConfirmModal
          open={leaveThePage}
          title="Tem certeza de que deseja sair sem gravar as alterações?"
          content="Toda a informação não gravada será perdida."
          okText="Sair"
          cancelText="Voltar"
          onOk={() => {
            setLeaveThePage(false);
            goSalesList();
          }}
          onCancel={() => setLeaveThePage(false)}
        ></ConfirmModal>

        <ConfirmModal
          open={openSendUpdatedInvoiceConfirm}
          title="Deseja enviar a fatura atualizada por-email agora?"
          onOk={async () => {
            if (!nextInvoiceUuidToSend) {
              setOpenSendUpdatedInvoiceConfirm(false);
              goSalesList();
              return;
            }

            setSendingUpdatedInvoiceLoading(true);
            try {
              await sendInvoice({ values: { updatedInvoice: "1" }, uuid: nextInvoiceUuidToSend });
              AlertService.sendAlert([{ text: "Fatura atualizada enviada por e-mail com sucesso.", type: "success" }]);
            } catch {
              AlertService.sendAlert([{ text: "Falha ao enviar fatura atualizada por e-mail.", type: "error" }]);
            } finally {
              setSendingUpdatedInvoiceLoading(false);
              setOpenSendUpdatedInvoiceConfirm(false);
              goSalesList();
            }
          }}
          onCancel={() => {
            setOpenSendUpdatedInvoiceConfirm(false);
            goSalesList();
          }}
          okText={sendingUpdatedInvoiceLoading ? "Enviando..." : "Sim, enviar"}
          cancelText="Cancelar"
        />
      </Card>
    </>
  );
}
